import { Paginated } from '@feathersjs/feathers';
import { LifeTransactionData } from '@tymbe/schema/life-transaction.interface';
import feathersClient from '../../../../apiClient';
import { useInfiniteQuery } from 'react-query';

const lifeTransactionPageSize = 10;

const getLifeTransactionsForPerson = (personId: string) =>
  async function getLifeTransactions({
    pageParam = 0,
  }): Promise<Paginated<LifeTransactionData>> {
    return await feathersClient.service('life-transaction').find({
      query: {
        'life_transaction.person_id': personId,
        $skip: pageParam * lifeTransactionPageSize,
        $limit: lifeTransactionPageSize,
        $sort: { 'life_transaction.created_at': -1 },
        $leftJoinRelation: 'application',
        $eager:
          '[application(withDeleted).[manShift(withDeleted).[shift(withDeleted)], lastExcuse(withDeleted)], creator]',
      },
    });
  };

export function useLifeTransactions(personId: string) {
  return useInfiniteQuery({
    queryKey: ['life-transactions', personId],
    queryFn: getLifeTransactionsForPerson(personId),
    getNextPageParam: (lastPage, pages) => {
      const totalPages = Math.ceil(lastPage.total / lifeTransactionPageSize);
      const currentlyFetchedPages = pages.length;
      return currentlyFetchedPages < totalPages
        ? currentlyFetchedPages
        : undefined;
    },
  });
}
